import React, { useState } from "react";

import {  useSearchParams } from "react-router-dom";
import useAxiosFetch from "../common/useAxiosFetch";

import RiskTemplateForm from "./RiskTemplateForm";
import LoadPage from "../common/LoadPage";
import { useTranslation } from "react-i18next";

const EditRiskTemplatePage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get("templateId");

  const { data, loading } = useAxiosFetch("/api/risktemplates/" + templateId);

  const [risks, setRisks] = useState([]);

  if (loading) {
    return <LoadPage />;
  } else if(data)  {
    // only set risks once
    if(risks.length === 0) {
      data.risks.map((risk) => {
        setRisks((risks) => [
          ...risks,
          { description: risk.description, availability: risk.availability, integrity: risk.integrity, confidentiality: risk.confidentiality },
        ]);
      });
    }

    return (
      <div id="content">
        <div id="content-title">{t('edit_risk_template')}</div>

        <div className="content-bubble">

            <RiskTemplateForm 
              risks={risks}
              setRisks={setRisks}
              riskTemplateData={data}
              templateId={templateId}
            />
        </div>
      </div>
    );
  }
};

export default EditRiskTemplatePage;
